import React, { useEffect, useRef, useState } from 'react'
import Breadcrumbs from '../layout/breadcrumb'
import Filter from "../../assets/Icons/filter.png"
import { useDownloadExcel } from 'react-export-table-to-excel';
import Close from "../../assets/Images/close.png";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PostHandoverComplaintForm from './post-handover-complaint-form';
import "../risk-register/risk.css"
import DprHeader from '../layout/dprHeader'
import { useLocation } from 'react-router-dom'
import { COMMON_API } from '../../services/apiCalls/commonApi';
import ExcelExport from '../../compnenets/commons/xls'

export default function PostHandoverComplaintList() {
    const location = useLocation();
    const pro = location.state || {};
    const [openFilter, setOpenFilter] = useState(false);
    const onCloseModalFilter = () => setOpenFilter(true);
    const [open, setOpen] = useState(false);
   
    const [selectedRows, setSelectedRows] = useState([]); 
    const [selectAll, setSelectAll] = useState(false);
    const [riskList, setRiskList] = useState([]);
    const [riskFilter,setRiskFilter]=useState({
        "ProjectName":"",
        "ProductCategory":"" ,
        "spoc_name":"",
        "Location" :"", 
        "complaintsCategory" :"",
        "RiskDescription" :"",
        "ImpactDescription" :"",
        "ImpactLevel" :0,        
        "complaintStatus" :"",
        "StartDate": "",
        "EndDate": "",
      
    })
const [activeTabIndex, setActiveTabIndex] = useState(0); // Manage active tab
  const [selectedRowData, setSelectedRowData] = useState(null); // Store selected row data

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData); // Set selected row data
    setActiveTabIndex(0); // Switch to "Issue Register Form" tab
  };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRiskFilter((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

   

    const getPostHandoverComplaintForm = async () => {
        const state = JSON.parse(localStorage.getItem("state"));
        setCurrentPage(1)
        let obj = {
            "UserID": state.user.user_id,

            //Filters Optional 

            SPOC: openFilter?riskFilter.spoc_name:'',
            ComplaintCategories: openFilter?riskFilter.complaintsCategory:"",
            Status: openFilter?riskFilter.complaintStatus:"",
            StartDate: openFilter?riskFilter.StartDate:"",
            EndDate: openFilter?riskFilter.EndDate:""

        }
        const postHandover = await COMMON_API.getPostHandoverComplaintForm(obj);
        // debugger
        if (postHandover.status === 200) {
            setRiskList(postHandover.postHandOverComplaintslist);
           setTimeout(() => {
            setOpenFilter(false)
           }, 1000);
            
        }else{
            setRiskList([]) 
        }
    }

    useEffect(() => {
        getPostHandoverComplaintForm();
    }, [])

 

    const tableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'machinery resources',
        sheet: 'Machinry'
    })
   

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const totalPages = Math.ceil(riskList.length / rowsPerPage);

    const handleClick = (page) => {
        setCurrentPage(page);
    };

    const paginatedData = riskList.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

   
    
    return <React.Fragment>
        <Breadcrumbs title="Post Handover Complaint" menu="" link="Post Handover Complaint" />
        <DprHeader project={pro} />
        <div className='pb-5 mt-3'>
            <div className='card card-none'>
                <div className='card-body' id="risk-register">
                    <Tabs selectedIndex={activeTabIndex}
              onSelect={(index) => setActiveTabIndex(index)}>
                        <TabList>
                            <Tab>Post Handover Complaint Form</Tab>
                            <Tab>Post Handover Complaint List</Tab>
                        </TabList>
                        <hr />
                        <TabPanel>
                            <div className='row'>
                                <div className='col-6'>
                                    {/* <PostHandoverComplaintForm  rowData={selectedRowData}/> */}
                                    <PostHandoverComplaintForm 
    rowData={selectedRowData} 
    setActiveTabIndex={setActiveTabIndex}  // Pass the function here
/>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className='row' style={{ marginRight: 25 }}>
                                <div className='d-flex justify-content-end'>
                                    <div className='download-icon'>
                                    <ExcelExport data={riskList?.map(val=>{
                                        return{
                                            "Project Name":val?.ProjectName,
                                            "Product Category":val?.ProductCategory,
                                            "Project Location":val?.Location,
                                            "Impact Level":val?.ImpactLevel,
                                            "Risk Due Date":val?.RiskDueDate,
                                            "Risk Status":val?.complaintStatus
                                        }
                                    })} fileName="Risk list"  sheet="Risk"/>
                                    </div>
                                    <div className='filter-icon mx-2 my-auto'>
                                        <img className='' onClick={() => { setOpenFilter(true) }} src={Filter} width={20} />
                                    </div>
                                    <div className="my-auto"
                                    onClick={()=>{
                                       
                                        setTimeout(() => {
                                            getPostHandoverComplaintForm()
                                        }, 500);
                                      }}
                                    >
              <span style={{cursor:"pointer",fontSize:12,fontWeight:500,background:"#8add79f7",padding:5,borderRadius:12}} >Clear filters</span>
            </div>
                                </div>
                            </div>
                            <div className="table-container">
                                <table className="custom-table">
                                    <thead className="table-header">
                                        <tr>                                         
                                            <th>Project Name</th>
                                            <th>Location</th>
                                            <th>State</th>
                                            <th>SPOC</th>
                                            <th>Complaints Categories</th>
                                            <th>Complaints Description</th>
                                            {/* <th>Actions</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((row, index) => (
                                            <tr key={index}
                                            onClick={() => handleRowClick(row)}
                                            style={{ cursor: "pointer" }} >
                                                {/* <td>
                                <input
                                    type="checkbox"
                                    checked={selectedRows.includes(row.id)}
                                    onChange={() => handleRowSelect(row.id)}
                                />
                            </td> */}
                                                <td id="elps" title={row.ProjectName}>{row.ProjectName}</td>
                                                <td id="elps" title={row.Location}>{row.Location ? row.Location : "-"}</td>
                                                <td id="elps" title={row.Sate}>{row.Sate ? row.state : '-'}</td>
                                                <td id="elps" title={row.SPOC}>{row.SPOC ? row.SPOC : "-"}</td>
                                                <td id="elps" title={row.ComplaintCategories}>{row.ComplaintCategories ? row.ComplaintCategories : '-'}</td>
                                                <td id="elps" title={row.ComplaintDescription}>{row.ComplaintDescription ? row.ComplaintDescription : "-"}</td>
                                                {/* <td style={{ cursor: 'pointer' }}>
                                <img src={Add} width={20} onClick={onOpenModal} />
                            </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div
                                    className="pagination"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 15px",
                                    }}
                                >
                                    <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                        Showing {Math.min((currentPage - 1) * rowsPerPage + 1, riskList.length)}{" "}
                                        to {Math.min(currentPage * rowsPerPage, riskList.length)} of{" "}
                                        {riskList.length} entries
                                    </div>

                                    <div
                                        className="pagination-buttons"
                                        style={{
                                            fontSize: "14px",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            width: "100%",
                                            gap: "5px",
                                        }}
                                    >
                                        {/* Left Arrow */}
                                        <button
                                            onClick={() => handleClick(Math.max(1, currentPage - 1))}
                                            disabled={currentPage === 1}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            <img
                                                src={leftArrow} // Replace with your actual image path
                                                alt="Previous"
                                                height="11px"
                                                width="7px"
                                                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                                            />
                                        </button>

                                        {/* Page Numbers */}
                                        {[...Array(totalPages)].map((_, i) => (
                                            <button
                                                key={i}
                                                onClick={() => handleClick(i + 1)}
                                                style={{
                                                    background: currentPage === i + 1 ? "#00B69B" : "transparent",
                                                    color: currentPage === i + 1 ? "#fff" : "#000",
                                                    border: "none",
                                                    borderRadius: "50%",
                                                    width: "30px",
                                                    height: "30px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {i + 1}
                                            </button>
                                        ))}

                                        {/* Right Arrow */}
                                        <button
                                            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
                                            disabled={currentPage === totalPages}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            <img
                                                src={rightArrow} // Replace with your actual image path
                                                alt="Next"
                                                height="11px"
                                                width="7px"
                                                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        </div>
        <Modal open={openFilter} onClose={onCloseModalFilter} center>
            <div className='d-flex justify-content-between'>
                <div>
                    <span className='resorces'>Post Handover Complaint Filter</span>
                </div>
                <div>
                    <img src={Close} width={20} onClick={() => { setOpenFilter(false) }} style={{ cursor: "pointer" }} />
                </div>
            </div>
            <hr />
            <div className='row'>
                <div className='card mt-0 card-bd-none'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-6'>
                                <label className='filter-label'>Start date</label>
                                <input type='date' onChange={handleChange} value={riskFilter.StartDate} name='StartDate' className='form-control shadow-none' />
                            </div>
                            <div className='col-6'>
                                <label className='filter-label'>End date</label>
                                <input type='date' onChange={handleChange} value={riskFilter.EndDate} name='EndDate' className='form-control shadow-none' />
                            </div>
                        </div>
                        <div className='row mt-1'>
                            <div className='col-6'>
                                <label className='filter-label'>SPOC name</label>
                                <input type='text' onChange={handleChange} value={riskFilter.spoc_name} name='spoc_name' className='form-control shadow-none' />
                            </div>
                            <div className='col-6'>
                                <label className='filter-label'>Complaints  Categories</label>
                                <select onChange={handleChange} value={riskFilter.complaintsCategory} name='complaintsCategory' className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                                <option value="">--Select status--</option>
                                <option value="one">One</option>
                                <option value="two">Two</option>
                                <option value="three">Three</option>
                                </select>
                            </div>
                        </div>
                        <div className='row mt-1'>
                            <div className='col-6'>
                                <label className='filter-label'> Status</label>
                                <select onChange={handleChange} value={riskFilter.complaintStatus} name='complaintStatus' className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                                <option value="">--Select status--</option>
                                <option value="Open">Open</option>
                                <option value="Close">Close</option>
                                </select>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='d-flex justify-content-between'>
                    <div style={{ marginLeft: 20 }}>
                        <span className='resorces'>Sort Project</span>
                    </div>
                    <div style={{ marginRight: 20 }}>
                        <select className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                            <option>ASC</option>
                            <option>DES</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className='row' style={{ marginLeft: 20 }}>
                <div class="form-check">
                    <input class="form-check-input shadow-none" type="radio" name="exampleRadios" id="Role" value="option1" />
                    <label for="Role" style={{ fontSize: 14 }}>
                        State
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input shadow-none" type="radio" name="exampleRadios" id="Type" value="option1" />
                    <label for="Type" style={{ fontSize: 14 }}>
                        SPOC Name
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input shadow-none" type="radio" name="exampleRadios" id="Created" value="option1" />
                    <label for="Created" style={{ fontSize: 14 }}>
                        Created date
                    </label>
                </div>
            </div>
            <div className='d-flex justify-content-center mt-4 pb-4'>
                <button onClick={(e)=>{
                     setOpenFilter(false)
                    getPostHandoverComplaintForm()
                    setRiskFilter({
                        "ProjectName":"",
                        "ProductCategory":"" ,
                        "spoc_name":"",
                        "Location" :"", 
                        "complaintsCategory" :"",
                        "RiskDescription" :"",
                        "ImpactDescription" :"",
                        "ImpactLevel" :"",        
                        "complaintStatus" :""  
                    }) 
                   
                }} className='btn btn-primary'>Filter</button>
            </div>
        </Modal>
      
    </React.Fragment>
}
